export default "__VITE_ASSET__9GIY3NaP__"